import humanFormat from 'human-format';

import {
  convertToCountScaleString,
  humanFormatMillionCountScale,
} from '@sbu/utils.string';

const ONE_MILLION = 1000000;
const ONE_BILLION = 1000000000;

export const humanFormatBigInteger = (bigInteger: bigInt.BigInteger) => {
  if (bigInteger.greater(ONE_BILLION)) {
    return humanFormat(bigInteger.divide(ONE_MILLION).toJSNumber(), {
      scale: humanFormatMillionCountScale,
    });
  }
  const separator = ' ';
  return convertToCountScaleString(bigInteger.toJSNumber(), separator);
};

export const bigIntegerToLocaleString = (bigInteger: bigInt.BigInteger) => {
  let i = 0;
  let formattedString = '';
  for (const c of bigInteger.toString().split('').reverse()) {
    if (i > 0 && i % 3 === 0) {
      formattedString = ',' + formattedString;
    }
    formattedString = c + formattedString;
    i++;
  }
  return formattedString;
};
